var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C14.8734 24 17.1935 23.2962 19.1668 21.9776C21.1402 20.6591 22.6783 18.7849 23.5866 16.5922C24.4948 14.3995 24.7324 11.9867 24.2694 9.65892C23.8064 7.33115 22.6635 5.19295 20.9853 3.51472C19.307 1.83649 17.1689 0.693605 14.8411 0.230582C12.5133 -0.232441 10.1005 0.00519931 7.9078 0.913451C5.71508 1.8217 3.84094 3.35977 2.52236 5.33316C1.20379 7.30655 0.5 9.62663 0.5 12C0.5 13.984 0.98 15.8547 1.83333 17.5027L0.5 24L6.99733 22.6667C8.64533 23.52 10.5173 24 12.5 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarChat);
export default __webpack_public_path__ + "static/media/sidebar_chat.9660ce3076f30dec5e87b511cd8c50d1.svg";
export { ForwardRef as ReactComponent };